"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function kya_required(composedFunc, errorMsg) {
    return function withRequired(arg) {
        return composedFunc(arg, false, errorMsg);
    };
}
exports.default = kya_required;



//////////////////
// WEBPACK FOOTER
// ../node_modules/kya/dist/exist/required.js
// module id = 330
// module chunks = 0